'use client';
import { OnbForm } from '@/components/form';
import { connectedField } from '@/redux/fields';
import { Stack, TextField, Typography } from '@mui/material';
import { bankAccountReference } from '@repo/onb-api';
import StepWrapper from './stepWrapper';

export default function BankAccountReference({
  stepname: stepName,
}: {
  stepname?: bankAccountReference['name'];
}): React.JSX.Element {
  return (
    <StepWrapper>
      <Typography variant="h1">Decinos los datos de la cuenta donde querés recibir tu dinero.</Typography>
      <Stack>
        <Typography component="p" variant="subtitle2">
          La cuenta tiene que estar a tu nombre.
        </Typography>
        <Typography component="p" variant="subtitle2">
          No podremos acreditar tu préstamo si es una cuenta de jubilación o ayuda social.
        </Typography>
      </Stack>
      <OnbForm<bankAccountReference> stepName={stepName!} submitLabel="Validar">
        <TextField
          label="Ingresá tu CBU/CVU"
          autoFocus
          placeholder="Ej: 285059094009041813520"
          slotProps={{ htmlInput: { 'data-testid': 'bankAccountReference', inputMode: 'numeric', maxLength: 22 } }}
          helperText="Tenés 3 intentos para validar tus datos, 
          asegurate de que estos estén correctamente ingresados."
          {...connectedField({
            stepName,
            name: 'bankAccountReference',
            required: true,
            beforeChange: (value) => value.replaceAll(/\D/g, ''),
            errorHandler: {
              type: 'text',
              errorText: 'El CBU/CVU ingresado no es válido. Revisalo y volvé a intentar',
              validate: (value) => value.length === 22,
            },
          })}
        />
      </OnbForm>
    </StepWrapper>
  );
}
